import { useAtom } from 'jotai';
import { resetPasswordDataAtom } from '@ibk/shared-utils';
export function useResetPasswordData() {
    const [resetPasswordData, setResetPasswordData] = useAtom(resetPasswordDataAtom);
    const setCpf = (cpf) => {
        setResetPasswordData(prev => ({ ...prev, cpf }));
    };
    const setMethod = (method) => {
        setResetPasswordData(prev => ({ ...prev, method }));
    };
    const setAccount = (account) => {
        setResetPasswordData(prev => ({ ...prev, accountData: account }));
    };
    const setDeviceId = (deviceId) => {
        setResetPasswordData(prev => ({ ...prev, deviceId }));
    };
    const clearData = () => {
        setResetPasswordData({ cpf: '', method: 'email', accountData: null, deviceId: null });
    };
    return {
        cpf: resetPasswordData.cpf,
        method: resetPasswordData.method,
        accountData: resetPasswordData.accountData,
        email: resetPasswordData.accountData?.email ?? '',
        deviceId: resetPasswordData.deviceId,
        setCpf,
        setMethod,
        setAccount,
        setDeviceId,
        clearData,
    };
}
